export const loggedInSubdomain = 'loggedin'

export enum Subdomain {
    actuary = 'actuary',
    pharmacy = 'pharmacy',
}
